 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"grid-match-overview~match-economy~team-map":"grid-match-overview~match-economy~team-map","team-map":"team-map","map":"map","player-matches":"player-matches","team-matches":"team-matches","team-reports":"team-reports","grid-match-overview":"grid-match-overview","match-economy":"match-economy","match-overview":"match-overview","match-performance":"match-performance","player":"player","player-map":"player-map","privacy-policy":"privacy-policy","terms-and-conditions":"terms-and-conditions"}[chunkId]||chunkId) + "." + {"chunk-19345d4c":"49cb6e33","chunk-36d46ab7":"2ded4303","chunk-3abf7d6b":"343d29c7","chunk-35c1f821":"0ff6c5f5","grid-match-overview~match-economy~team-map":"2d9ab095","team-map":"c1e9ac96","chunk-d26e0174":"bbb2e71b","chunk-297cf2b0":"1aa7cb64","chunk-45877dd6":"2d592cc0","chunk-92bd47fe":"5b7f7160","map":"eaaee687","chunk-fe83eb5c":"3fb6874d","chunk-53a0988e":"ce9e540c","chunk-041dfb8b":"5d672fa2","chunk-8e58251c":"2b919331","chunk-6b79bc86":"e1b16e4c","chunk-1c566fca":"d4c8bbae","chunk-7888ae04":"536e0f30","chunk-1d444135":"214d7311","chunk-b2ba337e":"95de68e2","chunk-f603289e":"79f7f72d","player-matches":"1ec69c41","team-matches":"94c40ee3","chunk-361e78c0":"5ea94647","chunk-74077ea0":"9d880e3f","chunk-c912b970":"122d2285","chunk-cd258826":"0e61021b","chunk-ee755510":"94be5d7c","chunk-3b8dad91":"530a0fbe","chunk-be0b4af6":"3fddf8ce","chunk-152ee576":"162bd925","chunk-7030cf17":"be6b15b9","chunk-468724cb":"adc92eae","chunk-76353d1e":"c24c2f67","chunk-570b5254":"be87a78f","chunk-1fb9a252":"e65156ae","chunk-7ecfb80a":"ef6b1b99","chunk-08e2119f":"913727a1","team-reports":"489c4586","chunk-e50ffd10":"a33f996b","grid-match-overview":"da34af69","match-economy":"60fc95bf","match-overview":"577a4bb1","match-performance":"64e40234","player":"606c49f5","player-map":"6ef3e6c4","privacy-policy":"781b418f","terms-and-conditions":"27ba0a69","chunk-2d0c15a5":"d9aa6064"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-19345d4c":1,"chunk-36d46ab7":1,"chunk-35c1f821":1,"grid-match-overview~match-economy~team-map":1,"team-map":1,"chunk-297cf2b0":1,"chunk-45877dd6":1,"chunk-92bd47fe":1,"map":1,"chunk-fe83eb5c":1,"chunk-8e58251c":1,"chunk-6b79bc86":1,"chunk-1c566fca":1,"chunk-7888ae04":1,"chunk-1d444135":1,"chunk-b2ba337e":1,"chunk-f603289e":1,"player-matches":1,"team-matches":1,"chunk-361e78c0":1,"chunk-74077ea0":1,"chunk-c912b970":1,"chunk-cd258826":1,"chunk-ee755510":1,"chunk-3b8dad91":1,"chunk-be0b4af6":1,"chunk-152ee576":1,"chunk-468724cb":1,"chunk-76353d1e":1,"chunk-570b5254":1,"chunk-1fb9a252":1,"chunk-7ecfb80a":1,"chunk-08e2119f":1,"grid-match-overview":1,"match-economy":1,"match-overview":1,"match-performance":1,"player":1,"player-map":1,"privacy-policy":1,"terms-and-conditions":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"grid-match-overview~match-economy~team-map":"grid-match-overview~match-economy~team-map","team-map":"team-map","map":"map","player-matches":"player-matches","team-matches":"team-matches","team-reports":"team-reports","grid-match-overview":"grid-match-overview","match-economy":"match-economy","match-overview":"match-overview","match-performance":"match-performance","player":"player","player-map":"player-map","privacy-policy":"privacy-policy","terms-and-conditions":"terms-and-conditions"}[chunkId]||chunkId) + "." + {"chunk-19345d4c":"9bc7d1fe","chunk-36d46ab7":"57e33901","chunk-3abf7d6b":"31d6cfe0","chunk-35c1f821":"8c278178","grid-match-overview~match-economy~team-map":"dc00c116","team-map":"b31728ab","chunk-d26e0174":"31d6cfe0","chunk-297cf2b0":"bcd15485","chunk-45877dd6":"f92cb6c3","chunk-92bd47fe":"64e9a94f","map":"82767d96","chunk-fe83eb5c":"cd9789be","chunk-53a0988e":"31d6cfe0","chunk-041dfb8b":"31d6cfe0","chunk-8e58251c":"debc80a0","chunk-6b79bc86":"2345117b","chunk-1c566fca":"141382a2","chunk-7888ae04":"0b593ac4","chunk-1d444135":"ae560d48","chunk-b2ba337e":"57a66e7b","chunk-f603289e":"311b2f17","player-matches":"3a9669f4","team-matches":"3a9669f4","chunk-361e78c0":"4526c774","chunk-74077ea0":"69fc75ef","chunk-c912b970":"49c80d9e","chunk-cd258826":"d4c77b32","chunk-ee755510":"78e934ed","chunk-3b8dad91":"065a6dc6","chunk-be0b4af6":"37568520","chunk-152ee576":"efe84402","chunk-7030cf17":"31d6cfe0","chunk-468724cb":"bd7c9937","chunk-76353d1e":"27297571","chunk-570b5254":"ecac843a","chunk-1fb9a252":"90e365d6","chunk-7ecfb80a":"06721184","chunk-08e2119f":"564ae26f","team-reports":"31d6cfe0","chunk-e50ffd10":"31d6cfe0","grid-match-overview":"88fdfae1","match-economy":"b7ed4066","match-overview":"e3be2cec","match-performance":"912d7a00","player":"4328aeb9","player-map":"b3cdfdb6","privacy-policy":"564ae26f","terms-and-conditions":"564ae26f","chunk-2d0c15a5":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
